<template>
  <div
    class="folda"
    @click="openFolder"
  >
    <router-link
      :to="{ name: 'FoldersDetail', params: { folderId: folder.id } }"
      class="folda__title"
    >{{ folder.name }}</router-link>
    <span class="folda__entries-count">
      {{ $tc('c.folder.label.entries', folder.contentsCount, {count: folder.contentsCount}) }}
    </span>

    <div
      v-if="folder.purpose && folder.purpose !== 'inbox'"
      class="folda__settings"
    >
      <dropdown-input
        :options="dropdownOptions"
        theme="primary"
        position="right"
        @select="handleDropdownSelect"
      >
        <button>
          <span class="fa fa-ellipsis-h" />
        </button>
      </dropdown-input>
    </div>
  </div>
</template>


<script>
import { mapActions } from 'vuex'
import pluralize from '@/filters/pluralize'
import FormMixin from '@/mixins/forms/Form'

export default {
  name: 'Folder',
  mixins: [FormMixin],
  filters: {
    pluralize
  },
  props: {
    folder: {
      type: Object,
      required: true
    }
  },
  computed: {
    dropdownOptions () {
      if (this.folder.purpose && this.folder.purpose === 'inbox')
      {
        return []
      } else {
        return [
          { label: 'Bearbeiten', value: 'edit', icon: 'edit' },
          { label: 'Löschen', value: 'delete', icon: 'trash' }
        ]
      }
    }
  },
  methods: {
    ...mapActions([
      'openFolderModalFolder',
      'openConfirmModal',
      'closeConfirmModal',
      'destroyFolder',
      'fetchTeams',
      'fetchFolders'
    ]),
    handleDropdownSelect ({ value }) {
      switch (value) {
        case 'edit':
          this.openFolderModalFolder(this.folder.id)
          break
        case 'delete':
          this.openConfirmModal({
            title: 'Folda löschen',
            message: `Den Folda ${this.folder.name} wirklich löschen?`,
            callback: () => {
              this.destroyFolder(this.folder.id)
                .then(this.fetchTeams)
                .then(this.fetchFolders)
                .then(this.closeConfirmModal)
            }
          })
          break
        default:
          window.alert(`action: ${value}`)
      }
    },
    openFolder () {
      this.$router.push({ name: 'FoldersDetail', params: { folderId: this.folder.id } })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/folders/Folder.vue